<template>
  <form class="side_box" :style="style" @submit.prevent="stopEditing">
    <table class="ref_box edit" v-if="!isEditing">
      <thead>
        <tr>
          <td></td>
          <td>REF</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="(subpart, index) in this.finalParts" 
          :key="index"
        >
          <td>{{subpart.amount}}x</td>
          <td>{{subpart.name}}</td>
          <td>
            <i class="icon icon-error fas fa-times-circle"></i>
          </td>
        </tr>
      </tbody>
    </table>
    <DynamicPartsList
      v-else
      :isDetailed="true"  
      label="Subparts"
      name="Subparts"
      :currentParts="finalParts"
      @updateParts="gotParts"
    />
    <div v-if="!isEditing && this.userDetails.isAdmin == 1" class="icon submit" @click="startEditing">
      <BaseIcon name="pen" class="icon" />
    </div>
    <button v-if="isEditing" class="no-btn icon submit" type="submit">
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import DynamicPartsList from '@/components/base/DynamicPartsList'

export default {
  components: {
    BaseIcon,
    DynamicPartsList,
  },
  computed: {
    style() {
      return "height: " + this.height + "%";
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  props: {
    height: String,
    details: Object
  },   
  mounted() {
    this.setStartValues()
  },
  data(){
    return {
      isEditing: false,
      finalParts: null,
      ref: "",
      deviceID: "",
      inValidFields: [],
    }
  },
  
  methods: {
    setStartValues() {
      this.ref = this.details.ref
      this.deviceID = this.details.deviceID
      if(this.details.subparts != null && this.details.subparts != undefined && this.details.subparts != [] ){
        this.finalParts = []
        for (var i = 0; i < this.details.subparts.length; i++) {
          this.finalParts.push({'id': this.details.subparts[i].subPartID, 'name': this.details.subparts[i].ref, 'amount': this.details.subparts[i].amount.toString()})
        }
      }
    },
    startEditing() {
      this.isEditing = true
    },
    putSteps() {
      var that = this

      this.$http.put(this.$endpoint + 'management/devices/assemblyPart', {
        "assemblyID": this.deviceID,
        "ref": this.ref,
        "parts": this.finalParts,
        "inspection": this.details.inspection,
        "IPC": this.details.ipc


      })
      .then(function (response) {
        that.$emit('refresh', true);        
        that.$swal(
          'Assembly updated!',
          `Your parts for this assembly has been successfully updated.`,
          'success'
        );
      })
      .catch(function (error) {
        that.$swal(
          'Oops that went wrong?',
          `Please contact the admin with the following info: ${ error }`,
          'error'
        );
      });
    },
    stopEditing() {
      this.isEditing = false
      this.putSteps()
    },
    gotParts(newParts) {
      this.finalParts = newParts
    }
  },
  watch:{
    details: {
      handler: function() {
        this.setStartValues()
        this.isEditing = false
      },
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
@import "@/style/components/sideBox.scss";
@import "@/style/components/lotDetailTable.scss";

.side_box {
  max-height: 440px;
}
</style>
